import type { CopilotScope } from "@productlane/lib/src/ai"

import { shouldRememberCopilotSession } from "@/lib/states/copilot-state"

// A "New chat" click always hands focus to the composer, including when the
// current chat is already empty and there is nothing to archive.
export function planNewSidebarAiChat({
	scope,
	isCurrentChatEmpty,
}: {
	scope: CopilotScope | null
	isCurrentChatEmpty: boolean
}): {
	focusScope: CopilotScope | null
	startsFreshChat: boolean
	clearsRememberedSession: boolean
} {
	const startsFreshChat = !isCurrentChatEmpty
	return {
		focusScope: scope,
		startsFreshChat,
		clearsRememberedSession:
			startsFreshChat && scope !== null && shouldRememberCopilotSession(scope),
	}
}
